import { useState, useEffect } from 'react';
import api from '../api';
import toast from 'react-hot-toast';

const OBJ = { human: '🚶 Žmonės', car: '🚗 Automobiliai', bike: '🚲 Dviračiai', bus: '🚌 Autobusai', truck: '🚛 Sunkvežimiai' };
const PER = { daily: 'Dienos', weekly: 'Savaitės', monthly: 'Mėnesio' };
const EMPTY = { camera_id: '', object_type: 'human', period: 'daily', target: '' };

export default function Goals() {
  const [goals,   setGoals]   = useState([]);
  const [cameras, setCameras] = useState([]);
  const [stats,   setStats]   = useState({});
  const [modal,   setModal]   = useState(false);
  const [form,    setForm]    = useState(EMPTY);
  const [editId,  setEditId]  = useState(null);

  useEffect(() => { loadAll(); }, []);

  async function loadAll() {
    const [g, c] = await Promise.all([api.get('/goals'), api.get('/cameras')]);
    setGoals(g.data); setCameras(c.data);
    // load current stats for each goal
    const now = new Date();
    const statsMap = {};
    for (const goal of g.data) {
      try {
        let from, to = now.toISOString().slice(0,16);
        if (goal.period === 'daily')   { from = new Date(now.setHours(0,0,0,0)).toISOString().slice(0,16); }
        if (goal.period === 'weekly')  { const d = new Date(); d.setDate(d.getDate()-d.getDay()+1); d.setHours(0,0,0,0); from = d.toISOString().slice(0,16); }
        if (goal.period === 'monthly') { from = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().slice(0,16); }
        const r = await api.get(`/reports/data?from=${from}&to=${to}&camera=${goal.camera_id||''}`);
        const rows = r.data?.timeSeries || [];
        const total = rows.reduce((s,row) => s + (row[goal.object_type]||0), 0);
        statsMap[goal.id] = total;
      } catch(e) { statsMap[goal.id] = 0; }
    }
    setStats(statsMap);
  }

  function openCreate() { setEditId(null); setForm(EMPTY); setModal(true); }
  function openEdit(g)  { setEditId(g.id); setForm({...g}); setModal(true); }

  async function handleSave(e) {
    e.preventDefault();
    try {
      if (editId) await api.put(`/goals/${editId}`, form);
      else        await api.post('/goals', form);
      toast.success(editId ? 'Atnaujinta' : 'Tikslas sukurtas');
      setModal(false); loadAll();
    } catch(err) { toast.error(err.response?.data?.error || 'Klaida'); }
  }

  async function handleDelete(id) {
    if (!window.confirm('Ištrinti tikslą?')) return;
    await api.delete(`/goals/${id}`); toast.success('Ištrinta'); loadAll();
  }

  return (
    <div>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <div className="page-title">Tikslai ir normos</div>
          <div className="page-subtitle">Nustatykite planuojamą srautą ir stebėkite vykdymą</div>
        </div>
        <button className="btn btn-primary" onClick={openCreate}>+ Naujas tikslas</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:20 }}>
        {goals.map(g => {
          const current = stats[g.id] || 0;
          const pct = Math.min(100, Math.round((current / g.target) * 100));
          const color = pct >= 100 ? '#10b981' : pct >= 70 ? '#f59e0b' : '#3b82f6';
          return (
            <div key={g.id} className="card">
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
                <div>
                  <div style={{ fontSize:13, color:'var(--text-muted)' }}>{OBJ[g.object_type]} • {PER[g.period]}</div>
                  <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:2 }}>{g.camera_name || 'Visos kameros'}</div>
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  <button className="btn btn-sm btn-secondary" onClick={() => openEdit(g)}>✏️</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(g.id)}>🗑️</button>
                </div>
              </div>
              <div style={{ display:'flex', alignItems:'flex-end', justifyContent:'space-between', marginBottom:10 }}>
                <div style={{ fontSize:36, fontWeight:800, color }}>{current.toLocaleString()}</div>
                <div style={{ fontSize:14, color:'var(--text-muted)' }}>/ {g.target.toLocaleString()}</div>
              </div>
              {/* Progress bar */}
              <div style={{ background:'var(--border)', borderRadius:6, height:10, overflow:'hidden', marginBottom:8 }}>
                <div style={{ width:`${pct}%`, height:'100%', background:color, borderRadius:6, transition:'width 0.5s' }} />
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:12 }}>
                <span style={{ color }}>{pct}% įvykdyta</span>
                <span style={{ color:'var(--text-muted)' }}>Trūksta: {Math.max(0, g.target - current).toLocaleString()}</span>
              </div>
              {pct >= 100 && (
                <div style={{ marginTop:10, padding:'6px 10px', background:'rgba(16,185,129,0.1)', borderRadius:6, fontSize:12, color:'#10b981', textAlign:'center' }}>
                  ✅ Tikslas pasiektas!
                </div>
              )}
            </div>
          );
        })}
        {!goals.length && (
          <div className="card" style={{ gridColumn:'1/-1', textAlign:'center', padding:60, color:'var(--text-muted)' }}>
            <div style={{ fontSize:40, marginBottom:12 }}>🎯</div>
            <div>Dar nėra tikslų. Sukurkite pirmąjį!</div>
          </div>
        )}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">{editId ? 'Redaguoti tikslą' : 'Naujas tikslas'}</div>
              <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Objekto tipas</label>
                  <select className="form-input" value={form.object_type} onChange={e => setForm({...form,object_type:e.target.value})}>
                    {Object.entries(OBJ).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Periodas</label>
                  <select className="form-input" value={form.period} onChange={e => setForm({...form,period:e.target.value})}>
                    {Object.entries(PER).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Kamera</label>
                  <select className="form-input" value={form.camera_id} onChange={e => setForm({...form,camera_id:e.target.value})}>
                    <option value="">Visos kameros</option>
                    {cameras.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Tikslas (objektų skaičius) *</label>
                  <input className="form-input" type="number" min="1" value={form.target} onChange={e => setForm({...form,target:e.target.value})} required />
                </div>
              </div>
              <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Atšaukti</button>
                <button type="submit" className="btn btn-primary">{editId ? 'Išsaugoti' : 'Sukurti'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
